import { Stack } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingPage() {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      height="300px"
      sx={{ bgcolor: "white" }}
    >
      <Stack direction="row" justifyContent="center">
        <CircularProgress color="primary" />
      </Stack>
    </Stack>
  );
}
